
export function setReactives(id, content) {
    for (const el of document.querySelectorAll(`[data-reactive-${id}]`)) {
        el.textContent = content;
    }
}